var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logistics-tabs"},[_c('div',{staticClass:"tabs container"},[_c('div',{staticClass:"tabs-list"},[_c('ul',_vm._l((_vm.innerMenu),function(item,index){return _c('li',{key:index,staticClass:"li",class:{on: item.isCur}},[_c('router-link',{staticClass:"link",attrs:{"to":{name:item.name}}},[_vm._v(_vm._s(item.title))])],1)}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }